/**
 * Orders icon: delivery truck/van line-art.
 * Uses the provided delivery vehicle icon image.
 */
export default function OrdersIcon({ size = 20, style = {} }) {
  return (
    <img
      src="/icons/orders-icon.png"
      alt=""
      width={size}
      height={size}
      style={{ display: 'block', flexShrink: 0, objectFit: 'contain', imageRendering: '-webkit-optimize-contrast', ...style }}
    />
  );
}
